<template>
    <v-card>
        <v-card-title class="justify-center">
            <h2>
                Tipo de desconto aplicado
            </h2>
        </v-card-title>
        <v-alert v-if="disabled" :value="true" color="error" icon="warning">
           Para trocar o tipo de desconto, você precisa cancelar as ofertas com desconto em reais
        </v-alert>
        <v-card-text class="pa-3">
            <v-select
                label="Tipo de desconto:"
                outline
                item-text="text"
                item-value="value"
                v-model="tipoDesconto"
                :disabled="disabled"
                :items="[
                    { text: 'Aplicado ao valor final da compra', value: 1 },
                    { text: 'Aplicado ao item', value: 2 }
                ]"
            />
              <div v-if="tipoDesconto == 1">
                <p style="font-size: 1.2em;">
                  Ao cliente realizar uma compra o valor do desconto será dado sobre o valor final da compra.<br>
                </p>
              <pre>Exemplo:
                  Desconto: %2
                  Valor da compra: R$ 100,00
                  Cálculo: R$ 100,00 - %2
                  Valor a pagar: R$ 98,00
                </pre>
                <v-flex ls12>
                  <v-checkbox
                    v-model="arredondar_valor"
                    label="Arredondar valor a pagar"
                  ></v-checkbox>
                </v-flex>
                <v-flex ls12>
                  <v-checkbox
                    v-model="arredondar_combustivel"
                    label="Arredondar valor do combustível com desconto"
                  ></v-checkbox>
                </v-flex>
            </div>
            <div v-else>
              <p style="font-size: 1.2em;">
                Ao cliente realizar uma compra o valor do desconto será dado sobre o preço do item.
              </p>
              <pre>Exemplo:
          Preço do combustível: R$ 7,84
          Desconto: %2
          Valor da compra: R$ 100,00
          Valor do combustível com desconto: R$ 7,68
          Calculo da quantidade de litros: R$ 100,00 &divide; R$ 7,84
          Quantidade de litros: 12,755 Litros
          Cálculo: R$ 7,68 x 12,755 L
          Valor a pagar: R$ 97,96
              </pre>
              <v-flex xs12>
                  <v-checkbox
                    v-model="litragem2Casas"
                    label="Utilizar 2 casas decimais na litragem"
                  ></v-checkbox>
                </v-flex>
                <v-flex ls12>
                  <v-checkbox
                    v-model="arredondar_valor"
                    label="Arredondar valor a pagar"
                  ></v-checkbox>
                </v-flex>
                <v-flex ls12>
                  <v-checkbox
                    v-model="arredondar_combustivel"
                    label="Arredondar valor do combustível com desconto"
                  ></v-checkbox>
                </v-flex>
            </div>
            <h3 v-if="posto.tipo_desconto === tipoDesconto" class="text-xs-center success--text">
              Você está utilizando essa forma
            </h3>
        </v-card-text>
        <v-card-actions class="justify-space-around">
            <v-btn round class="mb-3" @click="$emit('fechar')">Voltar</v-btn>
            <v-btn
                @click="alterarTipoDesconto"
                round
                class="mb-3"
                color="success"
                :disabled="posto.tipo_desconto === tipoDesconto && posto.litragem_2_casas === litragem2Casas && posto.truncamento === !arredondar"
            >Salvar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  data: () => ({
    tipoDesconto: 1,
    litragem2Casas: false,
    arredondar_valor: false,
    arredondar_combustivel: false,
    disabled: false
  }),
  computed: {
    posto () {
      return this.$store.getters.posto
    }
  },
  beforeMount () {
    this.tipoDesconto = this.posto.tipo_desconto
    this.litragem2Casas = this.posto.litragem_2_casas
    this.arredondar_valor = !this.posto.truncamento_valor
    this.arredondar_combustivel = !this.posto.truncamento_combustivel
    if (this.tipoDesconto === 2) this.verificarOferta()
  },
  methods: {
    alterarTipoDesconto () {
      this.$store.dispatch('alterarTipoDesconto', { tipo_desconto: this.tipoDesconto, litragem_2_casas: this.litragem2Casas, truncamento_valor: !this.arredondar_valor, truncamento_combustivel: !this.arredondar_combustivel }).then(() => {
        this.$emit('success', 'Tipo de desconto alterado com sucesso.')
        this.$emit('carregar')
        this.$emit('fechar')
      }).catch(() => {
        this.$emit('error', 'Não foi possível alterar o tipo de desconto utilizado, verifique sua situação junto a Apetrus.')
      })
    },
    verificarOferta () {
      const data = {}
      data.desconto_em_reais__isnull = false
      this.$store.dispatch('verificarOferta', data).then(json => {
        if (json.existe) {
          this.disabled = true
        }
      })
    }
  }
}
</script>
